import request from "../../utils/api";

export const login = body => request("users/login", { method: 'post', body });
export const logout = () => true;